import React from 'react';
import styled from 'styled-components';
import Cards from 'components/Cards/Cards';
import CardsGroup from 'components/Cards/CardsGroup';

const JobCards = ({ cards, clickedJobIndex, onJobClick }) => {
  if (cards?.length > 0) {
    return (
      <CardsGroup cols={3}>
        {cards.map((cardItem, index) => (
          <JobCard
            bodyType={'simple'}
            title={cardItem.name}
            description={`${cardItem.jobs.length} Open Positions`}
            ctaLink={'#job-section'}
            align={'center'}
            onClick={() => onJobClick(index)}
            selected={clickedJobIndex === index}
            key={index}
          />
        ))}
      </CardsGroup>
    );
  }

  return null;
};

export default JobCards;

const JobCard = styled(Cards)`
  .cards-blog--description p {
    font-weight: 500;
    font-size: 16px;
    line-height: 150%;
    color: var(--blue-primary);
  }
`;
